import {
  FETCH_BUNDLES,
  FETCH_BUNDLES_FAILURE,
  FETCH_BUNDLES_SUCCESS,
  TOGGLE_CONFIRM,
  TOGGLE_DELETE_PAYMENT,
  TOGGLE_SUB_MODAL,
  TOGGLE_CARD_LIST,
  SET_SUB_CART,
  RESET_SUB_CART,
  SUBSCRIBE,
  SUBSCRIBE_SUCCESS,
  SUBSCRIBE_FAILURE,
  UPDATE_SUBSCRIBE,
  UPDATE_SUBSCRIBE_SUCCESS,
  UPDATE_SUBSCRIBE_FAILURE,
  GET_PAYMENT_LIST,
  GET_PAYMENT_LIST_SUCCESS,
  GET_PAYMENT_LIST_FAILURE,
  GET_HISTORY,
  GET_HISTORY_SUCCESS,
  GET_HISTORY_FAILURE,
  ADD_METHOD,
  ADD_METHOD_SUCCESS,
  ADD_METHOD_FAILURE,
  EDIT_METHOD,
  EDIT_METHOD_SUCCESS,
  EDIT_METHOD_FAILURE,
  TOGGLE_CARD_MODAL,
  GET_SUB_LIST,
  GET_SUB_LIST_SUCCESS,
  GET_SUB_LIST_FAILURE,
  DELETE_METHOD,
  DELETE_METHOD_SUCCESS,
  DELETE_METHOD_FAILURE,
  CANCEL_SUBSCRIPTION,
  CANCEL_SUBSCRIPTION_SUCCESS,
  CANCEL_SUBSCRIPTION_FAILURE,
  SET_DEFAULT,
  SET_DEFAULT_SUCCESS,
  SET_DEFAULT_FAILURE,
  REQ_DEMO,
  REQ_DEMO_SUCCESS,
  REQ_DEMO_FAILURE,
} from "./constants";

export const fetchBundles = (payload) => ({
  type: FETCH_BUNDLES,
  payload,
});
export const fetchBundlesSuccess = (payload) => ({
  type: FETCH_BUNDLES_SUCCESS,
  payload,
});
export const fetchBundlesFailure = (payload) => ({
  type: FETCH_BUNDLES_FAILURE,
  payload,
});
export const toggleConfirm = (payload) => ({
  type: TOGGLE_CONFIRM,
  payload,
});
export const toggleSubModal = (payload) => ({
  type: TOGGLE_SUB_MODAL,
  payload,
});
export const setSubCart = (payload) => ({
  type: SET_SUB_CART,
  payload,
});
export const resetSubCart = (payload) => ({
  type: RESET_SUB_CART,
  payload,
});
export const subscribe = (payload, onSuccess, history, selectedMode) => ({
  type: SUBSCRIBE,
  payload,
  onSuccess,
  history,
  selectedMode,
});
export const subscribeSuccess = (payload) => ({
  type: SUBSCRIBE_SUCCESS,
  payload,
});
export const subscribeFailure = (payload) => ({
  type: SUBSCRIBE_FAILURE,
  payload,
});
export const updateSubscribe = (payload, onUpdateSuccess) => ({
  type: UPDATE_SUBSCRIBE,
  payload,
  onUpdateSuccess,
});
export const updateSubscribeSuccess = (payload) => ({
  type: UPDATE_SUBSCRIBE_SUCCESS,
  payload,
});
export const updateSubscribeFailure = (payload) => ({
  type: UPDATE_SUBSCRIBE_FAILURE,
  payload,
});
export const getPaymentList = (payload) => ({
  type: GET_PAYMENT_LIST,
  payload,
});
export const getPaymentListSuccess = (payload) => ({
  type: GET_PAYMENT_LIST_SUCCESS,
  payload,
});
export const getPaymentListFailure = (payload) => ({
  type: GET_PAYMENT_LIST_FAILURE,
  payload,
});
export const getHistory = (payload) => ({
  type: GET_HISTORY,
  payload,
});
export const getHistorySuccess = (payload) => ({
  type: GET_HISTORY_SUCCESS,
  payload,
});
export const getHistoryFailure = (payload) => ({
  type: GET_HISTORY_FAILURE,
  payload,
});
export const addMethod = (payload, onAddSuccess) => ({
  type: ADD_METHOD,
  payload,
  onAddSuccess,
});
export const addMethodSuccess = (payload) => ({
  type: ADD_METHOD_SUCCESS,
  payload,
});
export const addMethodFailure = (payload) => ({
  type: ADD_METHOD_FAILURE,
  payload,
});
export const editMethod = (payload) => ({
  type: EDIT_METHOD,
  payload,
});
export const editMethodSuccess = (payload) => ({
  type: EDIT_METHOD_SUCCESS,
  payload,
});
export const editMethodFailure = (payload) => ({
  type: EDIT_METHOD_FAILURE,
  payload,
});
export const deleteMethod = (payload) => ({
  type: DELETE_METHOD,
  payload,
});
export const deleteMethodSuccess = (payload) => ({
  type: DELETE_METHOD_SUCCESS,
  payload,
});
export const deleteMethodFailure = (payload) => ({
  type: DELETE_METHOD_FAILURE,
  payload,
});
export const toggleDeletePayment = (payload) => ({
  type: TOGGLE_DELETE_PAYMENT,
  payload,
});
export const toggleCardModal = (payload) => ({
  type: TOGGLE_CARD_MODAL,
  payload,
});
export const getSubList = (payload) => ({
  type: GET_SUB_LIST,
  payload,
});
export const getSubListSuccess = (payload) => ({
  type: GET_SUB_LIST_SUCCESS,
  payload,
});
export const getSubListFailure = (payload) => ({
  type: GET_SUB_LIST_FAILURE,
  payload,
});
export const cancelSubscription = (payload) => ({
  type: CANCEL_SUBSCRIPTION,
  payload,
});
export const cancelSubscriptionSuccess = (payload) => ({
  type: CANCEL_SUBSCRIPTION_SUCCESS,
  payload,
});
export const cancelSubscriptionFailure = (payload) => ({
  type: CANCEL_SUBSCRIPTION_FAILURE,
  payload,
});
export const toggleCardList = (payload) => ({
  type: TOGGLE_CARD_LIST,
  payload,
});
export const setDefault = (payload) => ({
  type: SET_DEFAULT,
  payload,
});
export const setDefaultSuccess = (payload) => ({
  type: SET_DEFAULT_SUCCESS,
  payload,
});
export const setDefaultFailure = (payload) => ({
  type: SET_DEFAULT_FAILURE,
  payload,
});

export const reqDemo = (payload, onSuccess) => ({
  type: REQ_DEMO,
  payload,
  onSuccess,
});
export const reqDemoSuccess = (payload) => ({
  type: REQ_DEMO_SUCCESS,
  payload,
});
export const reqDemoFailure = (payload) => ({
  type: REQ_DEMO_FAILURE,
  payload,
});
